// Klien real-time Alun-alun: satu WebSocket per kota (token warga = ikut bermain; tanpa token = penonton).
// Keadaan pemain disimpan di ref (dibaca loop render tiap frame); hanya hal yang memengaruhi UI React jadi state.
import { useCallback, useEffect, useRef, useState } from "react";
import { toast } from "sonner";

const WS_BASE = process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws");

export function useAlun(cityId, token) {
  const ref = useRef({ players: new Map(), meId: null, layout: null, offset: 0 });
  const wsRef = useRef(null);
  const fxRef = useRef(null);                 // dipasang halaman: f => renderer.tambahFx(f)
  const [status, setStatus] = useState("menyambung"); // menyambung | masuk | penonton | tolak | putus
  const [layout, setLayout] = useState(null);
  const [saldo, setSaldo] = useState(0);
  const [log, setLog] = useState([]);         // obrolan dekat terakhir {id, nama, teks, at, mine, sistem}
  const [ajakan, setAjakan] = useState(null); // {dari, nama}
  const [harapan, setHarapan] = useState([]);
  const [tolak, setTolak] = useState("");
  const [online, setOnline] = useState(0);
  const [tick, setTick] = useState(0);        // berubah saat daftar pemain berubah (kartu pemain, dsb)

  const now = useCallback(() => Date.now() + ref.current.offset, []);
  const kirim = useCallback(obj => { const ws = wsRef.current; if (ws && ws.readyState === 1) ws.send(JSON.stringify(obj)); }, []);
  const tambahLog = useCallback(item => setLog(l => [...l.slice(-7), { ...item, key: `${item.at}-${item.id}` }]), []);

  useEffect(() => {
    let ws, mati = false, ulang = 0, pingT;
    const S = ref.current;
    function sambung() {
      setStatus("menyambung");
      ws = new WebSocket(`${WS_BASE}/api/alun/ws/${cityId}${token ? `?token=${encodeURIComponent(token)}` : ""}`);
      wsRef.current = ws;
      ws.onopen = () => { ulang = 0; pingT = setInterval(() => ws.readyState === 1 && ws.send(JSON.stringify({ t: "ping" })), 20000); };
      ws.onmessage = ev => {
        let m; try { m = JSON.parse(ev.data); } catch { return; }
        const P = S.players;
        switch (m.t) {
          case "hai":
            S.offset = m.now - Date.now(); S.layout = m.layout; S.meId = m.me?.id || null;
            P.clear(); for (const p of m.pemain) P.set(p.id, p);
            setLayout(m.layout); setSaldo(m.saldo || 0); setHarapan(m.harapan || []); setStatus(m.me ? "masuk" : "penonton"); setOnline(P.size); setTick(x => x + 1);
            break;
          case "pong": S.offset = m.now - Date.now(); break;
          case "masuk": P.set(m.p.id, m.p); setOnline(P.size); setTick(x => x + 1); tambahLog({ id: m.p.id, nama: m.p.nama, teks: `${m.p.nama} tiba di alun-alun`, at: m.p.t0, sistem: true }); break;
          case "keluar": P.delete(m.id); setOnline(P.size); setTick(x => x + 1); break;
          case "jalan": { const p = P.get(m.id); if (p) { p.jalur = m.jalur; p.t0 = m.t0; p.duduk = null; } break; }
          case "duduk": { const p = P.get(m.id); if (p) { p.duduk = { b: m.b, slot: m.slot }; p.jalur = [[m.x, m.y]]; p.t0 = m.at || now(); } if (m.id === S.meId) setTick(x => x + 1); break; }
          case "berdiri": { const p = P.get(m.id); if (p) { p.duduk = null; if (m.x != null) { p.jalur = [[m.x, m.y]]; p.t0 = now(); } } if (m.id === S.meId) setTick(x => x + 1); break; }
          case "chat": { const p = P.get(m.id); if (p) p.bubble = { teks: m.teks, at: m.at }; tambahLog({ id: m.id, nama: m.nama, teks: m.teks, at: m.at, mine: m.id === S.meId }); break; }
          case "emote": { const p = P.get(m.id); if (p) { p.emote = m.k; p.emote_at = m.at; } if (m.ke && m.ke === S.meId && p) toast(`${p.nama} melambai padamu`); break; }
          case "avatar": { const p = P.get(m.id); if (p) p.avatar = m.avatar; break; }
          case "ajakan_joget": setAjakan({ dari: m.dari, nama: m.nama }); break;
          case "joget_ditolak": toast(`${m.oleh} belum mau joget sekarang`); break;
          case "joget_bareng": for (const id of [m.a, m.b]) { const p = P.get(id); if (p) { p.joget_sampai = m.sampai; p.emote = null; } } break;
          case "hadiah": toast.success(m.m); break;
          case "koin": {
            const p = P.get(m.id);
            if (p && fxRef.current && S.layout) { const a = S.layout.air_mancur; const pos = p.jalur?.[p.jalur.length - 1] || [a.x, a.y + 90]; fxRef.current({ jenis: "koin", x: pos[0], y: pos[1] - 20, ke: { x: a.x, y: a.y }, at: now(), ms: 1300 }); }
            if (p) p.bubble = { teks: m.teks ? `melempar koin: "${m.teks}"` : "melempar koin ke air mancur", at: m.at };
            setHarapan(h => [{ id: `${m.at}`, nama: m.nama, teks: m.teks, created_at: new Date(m.at).toISOString() }, ...h].slice(0, 20));
            break;
          }
          case "saldo": setSaldo(m.saldo); break;
          case "gagal": toast.error(m.m); break;
          case "tolak": mati = true; setTolak(m.m); setStatus("tolak"); break;
          default: break;
        }
      };
      ws.onclose = () => {
        clearInterval(pingT);
        if (wsRef.current === ws) wsRef.current = null;
        if (mati) return;
        setStatus("putus");
        const jeda = Math.min(8000, 800 * 2 ** ulang++);
        setTimeout(() => !mati && sambung(), jeda);
      };
      ws.onerror = () => {};
    }
    sambung();
    return () => { mati = true; clearInterval(pingT); try { ws && ws.close(); } catch { /* abaikan */ } };
  }, [cityId, token, now, tambahLog]);

  const aksi = {
    jalan: (x, y) => kirim({ t: "jalan", x, y }),
    chat: teks => kirim({ t: "chat", teks }),
    emote: (k, ke) => kirim({ t: "emote", k, ke }),
    duduk: (b, slot) => kirim({ t: "duduk", b, slot }),
    berdiri: () => kirim({ t: "berdiri" }),
    ajakJoget: ke => { kirim({ t: "ajak_joget", ke }); toast("Ajakan joget dikirim"); },
    jawabJoget: (dari, terima) => { kirim({ t: "jawab_joget", dari, terima }); setAjakan(null); },
    lemparKoin: teks => kirim({ t: "lempar_koin", teks }),
  };
  return { ref, fxRef, status, layout, saldo, log, ajakan, harapan, tolak, online, tick, now, aksi };
}
